"use client";

// src/components/default/arrow-left.tsx
import * as React from "react";
import { useUID } from "@stepstone-genesis/uid-library";
import { systemForwardRef } from "@stepstone-genesis/system";
import {
  IconContainer
} from "@stepstone-genesis/icon-containers";
var ArrowLeftIcon = systemForwardRef(
  function IconWrapper({ title, id, display, size, color, ...rest }, ref) {
    const identifier = useUID();
    const titleId = title ? `ArrowLeftIcon-${id != null ? id : identifier}` : void 0;
    const role = title ? "img" : "presentation";
    const componentName = `ArrowLeftIcon`;
    return /* @__PURE__ */ React.createElement(
      IconContainer,
      {
        ...rest,
        display,
        size,
        color,
        ref
      },
      /* @__PURE__ */ React.createElement(
        "svg",
        {
          "data-genesis-element": componentName,
          role,
          width: "100%",
          height: "100%",
          viewBox: "0 0 20 20",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          "aria-labelledby": titleId
        },
        title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
        /* @__PURE__ */ React.createElement(
          "path",
          {
            fill: "currentColor",
            d: "M6.49846 10.5416L10.3939 14.4371C10.501 14.5442 10.5572 14.6704 10.5626 14.8157C10.5679 14.961 10.5129 15.0946 10.3975 15.2166C10.2821 15.3307 10.1531 15.3864 10.0105 15.3838C9.86788 15.3811 9.7402 15.3233 9.62748 15.2104L4.88994 10.4666C4.82023 10.3968 4.76935 10.3234 4.73729 10.2464C4.70524 10.1694 4.68921 10.0862 4.68921 9.99663C4.68921 9.90712 4.70524 9.82386 4.73729 9.74686C4.76935 9.66988 4.81742 9.59934 4.88152 9.53524L9.6235 4.79326C9.73888 4.67787 9.86904 4.61884 10.014 4.61618C10.1589 4.61351 10.2868 4.67254 10.3975 4.79326C10.5129 4.90401 10.5706 5.03052 10.5706 5.17278C10.5706 5.31506 10.514 5.44278 10.4008 5.55595L6.49846 9.45832H15.0423C15.1958 9.45832 15.3244 9.50974 15.428 9.61257C15.5316 9.71542 15.5834 9.84309 15.5834 9.99557C15.5834 10.1481 15.5316 10.2772 15.428 10.383C15.3244 10.4887 15.1958 10.5416 15.0423 10.5416H6.49846Z"
          }
        )
      )
    );
  }
);
export {
  ArrowLeftIcon
};
